import React, {Component} from 'react';
import {getUserToken, removeUserToken, storeUserToken, verifyGoogleToken} from "../services/AuthService";

export class Login extends Component {
    static displayName = Login.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isLoggedIn: false
        };
        this.handleCredentialResponse = this.handleCredentialResponse.bind(this);
        this.logOut = this.logOut.bind(this);
    }

    componentDidMount() {
        const userToken = getUserToken();
        this.verifyToken(userToken).then(isLoggedIn => {
            this.setState({loading: false}, () => {
                if (!isLoggedIn) this.loadScript();
            });
        });
    }

    loadScript() {
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        script.id = "googleScript";
        script.onload = () => this.scriptLoaded();
        document.body.appendChild(script);
    }

    scriptLoaded() {
        if (window.google && window.google.accounts) {
            window.google.accounts.id.initialize({
                client_id: '865160934972-bis6acptf553sqm1fosa6227ld85167s.apps.googleusercontent.com',
                callback: this.handleCredentialResponse
            });
            // https://developers.google.com/identity/gsi/web/reference/js-reference#google.accounts.id.renderButton
            window.google.accounts.id.renderButton(document.getElementById("loginDiv"), {
                theme: 'outline',
                size: 'large'
            });
        }
    }

    handleCredentialResponse(response) {
        this.verifyToken(response.credential).then(r => r);
    }

    async verifyToken(token) {
        if (token === null) {
            return false;
        }

        const result = await verifyGoogleToken(token);
        if (result.isAuthenticated) {
            storeUserToken(token);
            this.setState({isLoggedIn: true, email: result.email});
            return true;
        }

        return false;
    }

    logOut() {
        removeUserToken();
        this.setState({isLoggedIn: false}, () => this.loadScript());
    }

    render() {
        if (this.state.loading) return <div>Indlæser...</div>
        if (this.state.isLoggedIn) return <div>
            <p><input type="button" value="Log ud" onClick={this.logOut} className="btn btn-warning"/></p>
            <p>Du er logget ind som {this.state.email}.</p></div>
        return <div>
            <div id="loginDiv"></div>
        </div>;
    }
}
